var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showKeyboard),expression:"showKeyboard"}]},[_c('SimpleKeyboard',{ref:"refSimpleKeyboard",staticClass:"Keyboard",on:{"onChange":_vm.onChangeKeyboard,"empty":_vm.empty}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }